import React from 'react'
import { Link } from 'gatsby'
import * as styles from './LinkList.module.scss'
import { Icon } from '@iconify/react'

const AboutLinkList = () => {
  return (
    <ul className={`${styles.navlist}`}>
      <li>
        <Link to="/who-we-are">
          <Icon
            className={`${styles.nav_icon}`}
            icon="fluent:target-arrow-20-filled"
            inline={true}
            height="24"
            width="24"
          />
          <span>Who We Are</span>
          <Icon
            className={`${styles.dropdownArrow__icon}`}
            icon="eva:arrow-ios-forward-fill"
            inline={true}
          />
        </Link>
      </li>
      <li>
        <Link to="/our-culture">
          <Icon
            className={`${styles.nav_icon}`}
            icon="maki:globe"
            inline={true}
            height="24"
            width="24"
          />
          <span>Our Culture</span>
          <Icon
            className={`${styles.dropdownArrow__icon}`}
            icon="eva:arrow-ios-forward-fill"
            inline={true}
          />
        </Link>
      </li>
      <li>
        <Link to="/ethics-sustainability">
          <Icon
            className={`${styles.nav_icon}`}
            icon="ri:plant-line"
            inline={true}
            height="24"
            width="24"
          />
          <span>Ethics &amp; Sustainability</span>
          <Icon
            className={`${styles.dropdownArrow__icon}`}
            icon="eva:arrow-ios-forward-fill"
            inline={true}
          />
        </Link>
      </li>
      <li>
        <Link to="/our-team">
          <Icon
            className={`${styles.nav_icon}`}
            icon="uil:users-alt"
            inline={true}
            hFlip={true}
            height="24"
            width="24"
          />
          <span>Our Leadership Team</span>
          <Icon
            className={`${styles.dropdownArrow__icon}`}
            icon="eva:arrow-ios-forward-fill"
            inline={true}
          />
        </Link>
      </li>
      <li>
        <Link to="/news">
          <Icon
            className={`${styles.nav_icon}`}
            icon="fluent:news-24-regular"
            inline={true}
            height="24"
            width="24"
          />
          <span>News &amp; Events</span>
          <Icon
            className={`${styles.dropdownArrow__icon}`}
            icon="eva:arrow-ios-forward-fill"
            inline={true}
          />
        </Link>
      </li>
    </ul>
  )
}

export default AboutLinkList
